import { map } from 'lodash'
import { takeLatest, put, all, call } from 'redux-saga/effects'
import * as CONST from 'Reducers/Mission/const'
import * as ERRORS from 'Reducers/Errors/const'
import { apiClient } from 'Module/API/Client'
import NProgress from 'nprogress'
import { callApi, afterCallApiInParallel } from 'Reducers/apiCall'
import { getParallelResponse } from 'Utils/Response'

/**
 *  Get missions by city id
 */
function* getMissionsByCitytId(action) {
  NProgress.start()
  try {
    const { cityId, data } = action
    const response = yield callApi(
      apiClient.getMissionsPageByCityId,
      cityId,
      data,
    )
    const responseJson = yield response.json()

    if (response.ok) {
      yield put({
        type: CONST.GET_MISSIONS_BY_CITY_ID_SUCCESS,
        payload: {
          missionsByCityId: responseJson.viewData,
          missionsByCityIdCount: responseJson.count,
        },
      })
    } else {
      yield put({
        type: ERRORS.PUSH_API_ERROR,
        error: responseJson,
      })
    }
  } catch (ex) {
    console.warn(ex)
  }

  NProgress.done()
}

/**
 * Get missions
 *
 * @param {Object} action
 */
function* getCampaignMissions(action) {
  NProgress.start()
  const response = yield callApi(
    apiClient.getCampaignMissions,
    action.campaignId,
  )
  const missions = yield response.json()

  if (response.ok) {
    yield put({
      type: CONST.GET_CAMPAIGN_MISSIONS_SUCCESS,
      payload: {
        campaignId: action.campaignId,
        missions,
      },
    })
  } else {
    yield put({
      type: ERRORS.PUSH_API_ERROR,
      error: missions,
    })
  }

  NProgress.done()
}

/**
 * Get mission by id
 */
function* getMissionById(action) {
  NProgress.start()
  try {
    const response = yield callApi(apiClient.getMissionById, action.missionId)
    const responseJson = yield response.json()

    if (response.ok) {
      yield put({
        type: CONST.GET_MISSION_BY_ID_SUCCESS,
        payload: {
          missionById: responseJson,
        },
      })
      if (action.callbacks && typeof action.callbacks.onSuccess === 'function')
        action.callbacks.onSuccess()
    } else {
      yield put({
        type: ERRORS.PUSH_API_ERROR,
        error: responseJson,
      })
    }
  } catch (ex) {}

  NProgress.done()
}

function* createMissionPickup(action) {
  NProgress.start()

  try {
    const { callbacks = {} } = action
    const response = yield callApi(
      apiClient.createMissionPickup,
      action.missionId,
      action.payload,
    )
    const responseJson = yield response.json()

    if (response.ok) {
      yield put({
        type: CONST.CREATE_MISSION_PICKUP_SUCCESS,
      })
      callbacks.onSuccess && callbacks.onSuccess()
    } else {
      yield put({
        type: ERRORS.PUSH_API_ERROR,
        error: responseJson,
      })
    }
  } catch (ex) {}

  NProgress.done()
}

/**
 * Update missions in parallel
 *
 * @param action
 */
function* updateMissionsAll(action) {
  NProgress.start()

  const { data, callbacks = {} } = action

  try {
    const response = yield all(
      map(data, ({ missionId, payload }) =>
        call(apiClient.updateMission, missionId, payload),
      ),
    )

    yield afterCallApiInParallel(response)

    const { ok, error } = yield getParallelResponse(response)
    if (ok) {
      yield put({ type: CONST.UPDATE_MISSIONS_ALL_SUCCESS })

      callbacks.onSuccess && callbacks.onSuccess()
    } else {
      yield put({
        type: ERRORS.PUSH_API_ERROR,
        error,
      })
      callbacks.onError && callbacks.onError()
    }
  } catch (ex) {}

  NProgress.done()
}

/**
 * Fetch missions that are scheduled for pickup
 *
 * @param action
 */
function* fetchScheduledMissionsPickupForCity(action) {
  const { cityId } = action

  NProgress.start()
  const response = yield callApi(apiClient.getScheduledPickups, cityId)
  const responseJson = yield response.json()

  try {
    return response.ok
      ? yield put({
          type: CONST.FETCH_SCHEDULED_PICKUPS_SUCCESS,
          payload: { missions: responseJson },
        })
      : yield put({ type: ERRORS.PUSH_API_ERROR, error: responseJson })
  } catch (ex) {}

  NProgress.done()
}

/**
 * Get missions by city id request watcher
 */
export function* watchGetMisssionsByCityId() {
  yield takeLatest(CONST.GET_MISSIONS_BY_CITY_ID, getMissionsByCitytId)
}

/**
 * Get missions watcher
 */
export function* watchGetCampaignMissions() {
  yield takeLatest(CONST.GET_CAMPAIGN_MISSIONS, getCampaignMissions)
}

/**
 * Get missions watcher
 */
export function* watchGetMissionById() {
  yield takeLatest(CONST.GET_MISSION_BY_ID, getMissionById)
}

export function* watchCreateMissionPickup() {
  yield takeLatest(CONST.CREATE_MISSION_PICKUP, createMissionPickup)
}

/**
 * Update mission request watcher
 */
export function* watchUpdateMissionsAll() {
  yield takeLatest(CONST.UPDATE_MISSIONS_ALL, updateMissionsAll)
}

/**
 * Trigger the API call to get the mission to pickup
 */
export function* watchFetchScheduledPickup() {
  yield takeLatest(
    CONST.FETCH_SCHEDULED_PICKUPS,
    fetchScheduledMissionsPickupForCity,
  )
}
